$(document).ready(function () {
    $('.btn-cart-add').on('click', function () {
        $(this).prop('disabled', true);
        $('.cart-error').hide();

        const data = {
            product_id: $(this).data('product-id'),
            amount: $(this).data('quantity') || 1,
            csrf_token: $(this).data('csrf-token'),
        }

        $.ajax({
            type: "POST",
            url: "/ax_cart?ajax=1&action=add",
            data: data,
            dataType: "json",
            success: function (response) {
                $('.btn-cart-add').prop('disabled', false);

                if (response.result === "OK") {
                    openModal("#cartAddSuccessModal");
                    return;
                }

                if (response.result === "FAIL" && response.message) {
                    if ($('.cart-error').length) {
                        $('.cart-error').text(response.message).show();
                    } else {
                        alert(response.message);
                    }
                    return;
                }

                openModal("#cartAddErrorModal");
            },
            error: function (error) {
                $('.btn-cart-add').prop('disabled', false);
                console.error("🚀 ~ Error adding product to cart:", error);
                openModal("#cartAddErrorModal");
            }
        });
        return;
    });

    $('.cart-table-products input[name="quantity"]').on('change', function () {
        const productId = $(this).data('product-id');
        const variantId = $(this).data('variant-id');
        const token = $(this).data('csrf');
        const amount = parseInt($(this).val());

        changeCartAmount(productId, variantId, amount, token, $(this));
    });

    $('.btn-cart-remove').on('click', function () {
        const productId = $(this).data('product-id');
        const variantId = $(this).data('variant-id');
        const token = $(this).data('csrf');

        changeCartAmount(productId, variantId, 0, token, $(this));
    });

    $('.carrier-item').on('click', function () {
		const id = $(this).data('id')
		const token = $(this).data('csrf')

        $('.carrier-item').removeClass('input-error');
        $('.cart-next-step').prop('disabled', true);

		$.ajax({
			type: 'POST',
			url: BASE_URL + '/ax_cart',
            dataType: 'json',
			data: {
				action: 'changeCarrier',
				carrier_id: id,
				csrf_token: token,
			},
			success: function (response) {
				$('#deliveryCost').html(response.cart.show_delivery_cost)
				$('#totalCost').html(response.cart.show_total_gross)

				if (typeof response.status !== 'undefined' && response.status !== 'success') {
					openModal("#cartErrorModal");
				}
				
                $('.cart-next-step').prop('disabled', false);
			},
			error: function () {
                $('.cart-next-step').prop('disabled', false);
                openModal("#cartErrorModal");
			},
		})
	});

    $('.payment-item').on('click', function () {
		const id = $(this).data('id')
		const token = $(this).data('token')

        $('.payment-item').removeClass('input-error');
        $('.cart-next-step').prop('disabled', true);

		$.ajax({
			type: 'POST',
			url: BASE_URL + '/ax_cart',
            dataType: 'json',
			data: {
				action: 'changePayment',
				payment_id: id,
				csrf_token: token,
			},
			success: function (response) {
				if (typeof response.status !== 'undefined' && response.status !== 'success') {
					openModal("#cartErrorModal");
				}
				
                $('.cart-next-step').prop('disabled', false);
			},
			error: function () {
                $('.cart-next-step').prop('disabled', false);
                openModal("#cartErrorModal");
			},
		})
	});

    $("#discount-code-form").attr("novalidate", true).on("submit", function (e) {
        e.preventDefault();

        const form = $(this);

        form.find(':required').each(function () {
            $(this).removeClass('input-error');
        });

        $('button[type="submit"]').prop('disabled', true);

        if (!form[0].checkValidity()) {
            form.find(":required").each(function () {
                if (!this.checkValidity()) {
                    $(this).addClass("input-error");
                }
            });
            $('button[type="submit"]').prop('disabled', false);
            return;
        }

        const formData = new FormData(form[0]);

        $.ajax({
            url: "/ax_cart",
            method: "post",
            dataType: "json",
            data: formData,
            success: function (response) {
                console.log("🚀 ~ response:", response)
            },
            error: () => form.find("input").addClass("input-error"),
        });
    });

    $('#cart-form').on('submit', function (e) {
        e.preventDefault();

        const isCarrierValid = $('.carrier-item:has(input:checked)').length > 0;
        const isPaymentValid = $('.payment-item:has(input:checked)').length > 0;

        if (!isPaymentValid) {
            $('.payment-item').addClass('input-error');
            window.scrollTo({ top: $('#payment-section').offset().top - 100, behavior: 'smooth' });
        }

        if (!isCarrierValid) {
            $('.carrier-item').addClass('input-error');
            window.scrollTo({ top: $('#delivery-section').offset().top - 100, behavior: 'smooth' });
        }

        if (isCarrierValid && isPaymentValid) {
            this.submit();
        }
    });
});

function changeCartAmount(productId, variantId, amount, token, trigger) {
    $('.cart-next-step').prop('disabled', true);
    trigger.prop('disabled', true);
    
    $.ajax({
        type: 'POST',
        url: BASE_URL + '/ax_cart',
        dataType: 'json',
        data: {
            action: 'updateQuantity',
            product_id: productId,
            variant_id: variantId,
            amount: amount,
            csrf_token: token,
        },
        success: function (response) {
            $('.cart-next-step').prop('disabled', false);
            trigger.prop('disabled', false);
            
            if (response.status != 'success') {
                openModal("#cartErrorModal");
                return;
            }

            if (response.total_price == null) {
                $.redirect('/');
                return;
            }

            if (amount === 0) {
                $('tr[data-product-id="' + productId + '"][data-variant-id="' + variantId + '"]').remove();
            }

            $('#productsTotal').html(response.total_price)
            $('#totalCost').html(response.total_price)
        },
        error: function () {
            $('.cart-next-step').prop('disabled', false);
            trigger.prop('disabled', false);

            openModal("#cartErrorModal");
        },
    });
}